// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/** Ripples */\n/** Elements */\n/* Palette generated by Material Palette - materialpalette.com/blue/amber */\n/** Ripples */\n/** Elements */\n.no-card li[data-v-1e7a90ff] {\n  -webkit-box-shadow: unset !important;\n  box-shadow: unset !important;\n}\n.flag-chip-wrapper[data-v-1e7a90ff] {\n  display: inline-block;\n  padding-right: 6px;\n  width: 25%;\n}\n@media only screen and (max-width: 600px) {\n.flag-chip-wrapper[data-v-1e7a90ff] {\n    width: 33%;\n}\n}", ""]);
// Exports
module.exports = exports;
